// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-blog-post-js": () => import("/usr/src/app/src/pages/blogPost.js" /* webpackChunkName: "component---src-pages-blog-post-js" */),
  "component---src-pages-404-js": () => import("/usr/src/app/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/usr/src/app/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-projects-js": () => import("/usr/src/app/src/pages/projects.js" /* webpackChunkName: "component---src-pages-projects-js" */),
  "component---src-pages-work-experience-js": () => import("/usr/src/app/src/pages/work-experience.js" /* webpackChunkName: "component---src-pages-work-experience-js" */)
}

